import urlPrefixes from '../../../constants/urlPrefixes';

type THashedFriendlyAttributesParams = {
  [key: string]: string[] | string | number;
};

export default (hashedFriendlyAttributes: THashedFriendlyAttributesParams) => {
  // trim null values
  Object.keys(hashedFriendlyAttributes).forEach(
    (key) => hashedFriendlyAttributes[key] === null && delete hashedFriendlyAttributes[key],
  );

  const keys = Object.keys(hashedFriendlyAttributes);

  return keys
    .map((key) => {
      const attrValues = hashedFriendlyAttributes[key];
      const values = Array.isArray(attrValues) ? attrValues.join(',') : attrValues;
      return `${key}${urlPrefixes.nonTrackingDefiner}${values}`;
    })
    .join(urlPrefixes.nonTrackingSeparator);
};
